module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading"
    }]
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.elementVisible),
      expression: "elementVisible"
    }],
    staticClass: "loadingpage"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("A Smile Is The Prettiest Thing You Can Wear")]), _c('div', {
    staticClass: "logo"
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)]), (_vm.props && !_vm.$store.state.loading) ? _c('div', {
    staticClass: "pageinner"
  }, [_c('BaseBaseAccess'), (_vm.props) ? _c('NavDesktop', {
    attrs: {
      "props": _vm.props.pages.nav.acf
    }
  }) : _vm._e(), (_vm.props) ? _c('NavMobile', {
    attrs: {
      "props": _vm.props.pages.nav.acf
    }
  }) : _vm._e(), (_vm.props) ? _c('NavTrigger') : _vm._e(), _c('router-view'), (this.$store.state.showModal) ? _c('Modal') : _vm._e(), _c('FooterDesktop', {
    attrs: {
      "props": _vm.props.pages.footer
    }
  }), _c('FooterMobile', {
    attrs: {
      "props": _vm.props.pages.footer
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10373c1b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/base/app.pug
// module id = 583
// module chunks = 1